import { Link } from "react-router-dom";

const BreadCrumb = (props) => {
  const { links } = props;

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {links.map((v, i) => (
          <li key={i} className={`breadcrumb-item ${!v.to ? "active" : ""}`}>
            {!v.to ? (<span>{v.title}</span>) : (<Link to={v.to}>{v.title}</Link>)}
          </li>))}
      </ol>
    </nav>
  );
};

export { BreadCrumb };
